import { wrapLines } from "@/lib/zikirCard";
import { logWarn } from "@/lib/log";

// Square (1080×1080) emerald+gold "done today" card for a completed daily worship, e.g. Zikir Pagi.
const W = 1080;
const PAD = 100;
const GOLD = "#E6C25C";
const GOLD_DEEP = "#D4AF37";
const WHITE = "#ffffff";
const SUB = "rgba(255,255,255,0.82)";

export async function buildDoneCard({ headline, dateLine, hijriLine, streakLine, name, labels }) {
  try { await document.fonts.ready; } catch (e) { logWarn("fonts not ready, using system fonts:", e); }
  const SERIF = (px, w = "") => `${w} ${px}px "Playfair Display", Georgia, serif`.trim();
  const SANS = (px, w = "") => `${w} ${px}px "Plus Jakarta Sans", Arial, sans-serif`.trim();
  const AR = (px) => `${px}px UthmanicHafs, "Traditional Arabic", Georgia, serif`;

  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = W;
  const ctx = canvas.getContext("2d");
  const g = ctx.createLinearGradient(0, 0, W, W);
  g.addColorStop(0, "#0a3b2b"); g.addColorStop(0.55, "#0f5a3f"); g.addColorStop(1, "#0a3b2b");
  ctx.fillStyle = g; ctx.fillRect(0, 0, W, W);
  const rg = ctx.createRadialGradient(W / 2, 400, 40, W / 2, 400, 520);
  rg.addColorStop(0, "rgba(230,194,92,0.25)"); rg.addColorStop(1, "rgba(230,194,92,0)");
  ctx.fillStyle = rg; ctx.fillRect(0, 0, W, W);
  ctx.strokeStyle = GOLD_DEEP; ctx.lineWidth = 8; ctx.strokeRect(44, 44, W - 88, W - 88);
  ctx.lineWidth = 2; ctx.strokeRect(64, 64, W - 128, W - 128);

  ctx.textAlign = "center";
  ctx.fillStyle = GOLD; ctx.font = AR(46); ctx.direction = "rtl";
  ctx.fillText("ٱلْحَمْدُ لِلَّٰهِ", W / 2, 150);
  ctx.direction = "ltr";
  ctx.fillStyle = SUB; ctx.font = SANS(24);
  if ("letterSpacing" in ctx) ctx.letterSpacing = "5px";
  ctx.fillText((labels.brand || "Manasik").toUpperCase(), W / 2, 196);
  if ("letterSpacing" in ctx) ctx.letterSpacing = "0px";

  // Check badge
  const cy = 400;
  ctx.beginPath(); ctx.arc(W / 2, cy, 118, 0, Math.PI * 2);
  ctx.fillStyle = "rgba(230,194,92,0.16)"; ctx.fill();
  ctx.lineWidth = 6; ctx.strokeStyle = GOLD; ctx.stroke();
  ctx.beginPath(); ctx.arc(W / 2, cy, 84, 0, Math.PI * 2); ctx.fillStyle = GOLD; ctx.fill();
  ctx.strokeStyle = "#0a3b2b"; ctx.lineWidth = 16; ctx.lineCap = "round"; ctx.lineJoin = "round";
  ctx.beginPath(); ctx.moveTo(W / 2 - 40, cy + 2); ctx.lineTo(W / 2 - 8, cy + 36); ctx.lineTo(W / 2 + 48, cy - 34); ctx.stroke();

  let y = 600;
  ctx.fillStyle = WHITE; ctx.font = SERIF(58, "bold");
  for (const ln of wrapLines(ctx, headline, SERIF(58, "bold"), W - PAD * 2).slice(0, 3)) { ctx.fillText(ln, W / 2, y); y += 72; }
  y += 14;
  ctx.fillStyle = SUB; ctx.font = SANS(30);
  ctx.fillText(dateLine, W / 2, y); y += 44;
  if (hijriLine) { ctx.fillStyle = GOLD; ctx.font = SANS(28, "600"); ctx.fillText(hijriLine, W / 2, y); y += 56; } else y += 12;

  if (streakLine) {
    ctx.font = SANS(28, "bold");
    const tw = ctx.measureText(streakLine).width + 72;
    const px = W / 2 - tw / 2, py = y - 4, ph = 62;
    ctx.fillStyle = "rgba(230,194,92,0.18)";
    ctx.beginPath(); ctx.roundRect ? ctx.roundRect(px, py, tw, ph, 31) : ctx.rect(px, py, tw, ph); ctx.fill();
    ctx.strokeStyle = GOLD; ctx.lineWidth = 2; ctx.stroke();
    ctx.fillStyle = GOLD;
    ctx.fillText(`★ ${streakLine}`, W / 2, py + 42);
  }

  if (name) { ctx.fillStyle = WHITE; ctx.font = SANS(30, "600"); ctx.fillText(name, W / 2, W - 150); }
  ctx.fillStyle = SUB; ctx.font = SANS(26);
  ctx.fillText(labels.footer || "Manasik — Panduan Umrah & Haji", W / 2, W - 92);

  const blob = await new Promise((r) => canvas.toBlob(r, "image/png"));
  return { blob, url: URL.createObjectURL(blob) };
}

export async function shareBlob(blob, { title, text, filename = "manasik-zikir-selesai.png" }) {
  const file = new File([blob], filename, { type: "image/png" });
  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) { await navigator.share({ files: [file], title, text }); return "shared"; }
  } catch (e) { logWarn("Web Share cancelled/unsupported, falling back:", e); }
  downloadBlob(blob, filename);
  window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`, "_blank");
  return "downloaded";
}

export function downloadBlob(blob, filename = "manasik-zikir-selesai.png") {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}
